import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { ThemeTokens } from '@repo/types';

// 30 minutes frontend cache for theme query
const CACHE_TIME = 30 * 60 * 1000;

export const useThemeQuery = () => {
  return useQuery({
    queryKey: ['theme'],
    queryFn: fetchTheme,
    staleTime: CACHE_TIME,
  });
};

const fetchTheme: QueryFunction<ThemeTokens | null, [string]> = async () => {
  const { data } = await axios.get<ThemeTokens | null>(API.endpoints.themeSettings);
  return data;
};
